import React, { useState } from 'react';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Box from '@mui/joy/Box';


export default function StepFive({
    getDataFromStepFiveValues,
    dataObjKilo
}) {
    const [valuesKm, setValuesKm] = useState(dataObjKilo)

    const handleInputChange = (index, event) => {
        const newInputs = [...valuesKm];
        if(!newInputs.at(index)?.price){
            newInputs[index] = {price:0}
        }
        newInputs[index].price
            = event.target.value;
            console.log(" VAlue > ", event.target.value)
            setValuesKm(newInputs);
            getDataFromStepFiveValues(newInputs)
    };
    

    return (
        <Grid
            container
            direction='row'
            spacing={4}
        >
            <Grid xs={12}>
                <Typography level="h3" sx={{ fontSize: '16px', color: '#434448' }}>مبلغ الخصم في المسافة المقطوعة</Typography>
            </Grid>
            <Grid xs={12}>
                <Box component="section" sx={{ display: 'flex', width: '100%', gap: '20px' }}>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من صفر الى 10الاف كيلومتر</FormLabel>
                        <Input 
                            placeholder="1.25%" 
                            type='number' 
                            sx={{ borderRadius: '30px', height: '60px' }} 
                            value={valuesKm[0] ? valuesKm[0].price: 0}
                            onChange={(e) => handleInputChange(0, e)}
                            />
                    </FormControl>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من 10الاف الي 20الف كيلومتر</FormLabel>
                        <Input 
                        placeholder="1.75%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[1] ? valuesKm[1].price: 0}
                        onChange={(e) => handleInputChange(1, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من 20الف الى 40الف كيلومتر</FormLabel>
                        <Input 
                        placeholder="2.25%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[2] ? valuesKm[2].price: 0}
                        onChange={(e) => handleInputChange(2, e)}
                        />
                    </FormControl>
                </Box>
            </Grid>

            <Grid xs={12}>
                <Box component="section" sx={{ display: 'flex', width: '100%', gap: '20px' }}>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من 40 الف الى 60 الف كم </FormLabel>
                        <Input 
                        placeholder="2.40%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[3] ? valuesKm[3].price: 0}                        
                        onChange={(e) => handleInputChange(3, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من 60 الف الى 80 الف كم </FormLabel>
                        <Input 
                        placeholder="2.70%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[4]? valuesKm[4].price: 0}                        
                        onChange={(e) => handleInputChange(4, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من 80 الف الى 100 الف كم </FormLabel>
                        <Input 
                        placeholder="2.90%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[5]? valuesKm[5].price: 0}                        
                        onChange={(e) => handleInputChange(5, e)}
                        />
                    </FormControl>
                </Box>
            </Grid>

            <Grid xs={12}>
                <Box component="section" sx={{ display: 'flex', width: '100%', gap: '20px' }}>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من 100 الف الى 130 الف كم </FormLabel>
                        <Input 
                        placeholder="3.15%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[6]? valuesKm[6].price:0}                        
                        onChange={(e) => handleInputChange(6, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من 130 الف الى 160 الف كم </FormLabel>
                        <Input 
                        placeholder="3.35%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[7]? valuesKm[7].price:0}                        
                        onChange={(e) => handleInputChange(7, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من 160 الف الى 200 الف كم </FormLabel>
                        <Input 
                        placeholder="3.60%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[8]? valuesKm[8].price:0}                        
                        onChange={(e) => handleInputChange(8, e)}
                        />
                    </FormControl>
                </Box>
            </Grid>
            <Grid xs={12}>
                <Box component="section" sx={{ display: 'flex', width: '100%', gap: '20px' }}>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>من 200 الف الى 250 الف كم </FormLabel>
                        <Input 
                        placeholder="3.80%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[9]? valuesKm[9].price:0}                        
                        onChange={(e) => handleInputChange(9, e)}
                        />
                    </FormControl>
                    <FormControl sx={{ width: '30%' }}>
                        <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>اكثر من 250 الف كم </FormLabel>
                        <Input 
                        placeholder="4.0%" 
                        type='number' 
                        sx={{ borderRadius: '30px', height: '60px' }} 
                        value={valuesKm[10]? valuesKm[10].price:0}                        
                        onChange={(e) => handleInputChange(10, e)}
                        />
                    </FormControl>
                </Box>
            </Grid>

        </Grid>
    );
}